import React from 'react';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import type Constituent from '@/types/api/Constituent';

function ConstituentValue({ value }: { value: string }) {
  const { data }: { data?: Constituent } = useConstituent(value);

  return data ? <span>{data.displayName}</span> : null;
}

export default ConstituentValue;
